import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _RequestMaintenance, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}


interface Props {
    configProcedure: ProcedureFunctions;
}

export const MD007 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_RequestMaintenance);
    const [props, setProps] = useState<any>({});
    const [request, setRequest] = useState<any>({});

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    useEffect(() => {
        instance.getRequestMaintenanceCatalogPorPropiedades({ IDProceudreIMP: props.IDProceudreIMP }, null).then(
            (resp) => {
                if (resp?.length > 0 && resp[0].DataBeanProperties) {
                    const x = resp[0].DataBeanProperties;
                    setRequest(x);
                    if (x.ReferenceSpareInventoried) {
                        setLista(x.ReferenceSpareInventoried ? JSON.parse(x.ReferenceSpareInventoried) : [])
                    }
                }
            }
        ).catch(
            err => { console.log("No se pudo cargar la informacion") }
        )
    }, [props])

    const onExportMap = (obj?: any) => {
        instance.updateRequestMaintenance({ ...request }).then(
            (resp) => {
                if (configProcedure?._pushInfo) {
                    configProcedure?._pushInfo(bean.Obs);
                }
                if (configProcedure?._exportMap) {
                    configProcedure?._exportMap({ ...bean, Diagnosis: obj });
                }
            }
        ).catch(
            err => { toast.error("No se pudo realizar la acción") }
        );

    };

    return (
        <div className="row">
            <div className="col-md-12">
                <label>Justificación</label>
                <textarea className="form-control" value={bean.Obs} onChange={(e) => { setBean({ ...bean, Obs: e.target.value }) }} />
            </div>
            <div className="col-md-12 mt-4">
                <div className="row d-flex justify-content-between">
                    <div className="col-md-6">
                        <BasicButton clase="success" eventClick={() => { onExportMap("Internal") }} icon="ri-send-plane-line" children={`Daño Interno`} />
                    </div>
                    <div className="col-md-6 d-flex justify-content-end">
                        <BasicButton clase="danger" eventClick={() => { onExportMap("Third") }} icon="ri-send-plane-line" children={`Daño de Tercero`} />
                    </div>
                </div>
            </div>
        </div>
    )
}